module.exports = __webpack_public_path__ + "img/no_worries_02.fbb01ff4.png";